import { OwnedNFT } from 'src/common/types/models/Tokens'
import {
  addNewAssets as _addNewAssets,
  withdrawAssets as _withdrawAssets,
  AddNewAssetsParams,
  WithdrawAssetsParams,
} from 'src/thirdweb/carbon_bundle'
import useCarbonBundleContract from './useCarbonBundleContract'

const useCarbonBundle = () => {
  const contract = useCarbonBundleContract()

  const depositNewAssets = (assets: OwnedNFT[]) => {
    const _assets: AddNewAssetsParams['assets'] = assets.map(nft => ({
      assetAddress: nft.contractAddress,
      tokenId: BigInt(nft.tokenId),
      amount: BigInt(1),
      assetType: 2,
    }))

    const depositNewAssetsTx = _addNewAssets({
      contract,
      assets: _assets,
    })

    return depositNewAssetsTx
  }

  const withdrawAssets = (assets: OwnedNFT[]) => {
    const _assets: WithdrawAssetsParams['assets'] = assets.map(nft => ({
      assetAddress: nft.contractAddress,
      tokenId: BigInt(nft.tokenId),
      amount: BigInt(1),
      assetType: 2,
    }))

    const withdrawAssetsTx = _withdrawAssets({
      contract,
      assets: _assets,
    })

    return withdrawAssetsTx
  }

  return {
    depositNewAssets,
    withdrawAssets,
  }
}

export default useCarbonBundle
